import React from 'react';
import LegalPageLayout, { H2, P, UL } from '../../components/LegalPageLayout';

export default function GrievanceRedressal() {
  return (
    <LegalPageLayout title="Grievance Redressal" lastUpdated="May 31, 2026" testId="grievance-page">
      <P>
        In accordance with the Information Technology Rules, 2021 and the Consumer Protection Act, 2019,
        SecondDoctorOpinion.com has appointed a Grievance Officer to address user complaints in a timely
        manner.
      </P>

      <H2>Grievance Officer</H2>
      <div className="bg-surface-secondary rounded-lg p-5 my-4">
        <P>
          <strong>Name:</strong> Mr. Shivaam Kesarwaani<br />
          <strong>Designation:</strong> Grievance Officer & Co-Founder<br />
          <strong>Email:</strong> grievance@seconddoctoropinion.com<br />
          <strong>WhatsApp:</strong> +91 88408 04798<br />
          <strong>Address:</strong> Lucknow, Uttar Pradesh, India<br />
          <strong>Office Hours:</strong> Monday – Saturday, 10 AM – 6 PM IST
        </P>
      </div>

      <H2>How to File a Grievance</H2>
      <P>Send an email to <strong>grievance@seconddoctoropinion.com</strong> with the following details:</P>
      <UL>
        <li>Your full name and registered email/mobile number</li>
        <li>Your Case ID (if applicable)</li>
        <li>Detailed description of the issue or complaint</li>
        <li>Date of the incident or transaction</li>
        <li>Any supporting documents, screenshots, or records</li>
        <li>The resolution you are seeking</li>
      </UL>

      <H2>Response Timelines</H2>
      <UL>
        <li><strong>Acknowledgement:</strong> Within 24 hours of receipt</li>
        <li><strong>Initial response:</strong> Within 7 business days</li>
        <li><strong>Resolution:</strong> Within 15 business days for most issues; complex grievances may take up to 30 days, in which case interim updates will be provided every 7 days</li>
      </UL>

      <H2>Types of Grievances Handled</H2>
      <UL>
        <li>Payment disputes and refund issues</li>
        <li>Concerns about the quality or content of a medical opinion</li>
        <li>Privacy and data handling concerns</li>
        <li>Inappropriate conduct by any platform user or specialist</li>
        <li>Account access or technical issues</li>
        <li>Complaints under the DPDP Act, 2023</li>
      </UL>

      <H2>What Falls Outside Our Scope</H2>
      <UL>
        <li>Medical advice itself — we are not a regulator of medical practice. Disagreements with a specialist's clinical judgment do not constitute a grievance unless there is evidence of negligence or breach of our standards.</li>
        <li>Complaints about your primary doctor or another hospital where you received in-person care.</li>
      </UL>

      <H2>Escalation</H2>
      <P>
        If you are not satisfied with our resolution, you may:
      </P>
      <UL>
        <li>Escalate to the relevant State Medical Council where the specialist is registered (for medical practice concerns)</li>
        <li>File a complaint with the Data Protection Board of India (for data privacy matters under DPDP Act)</li>
        <li>Approach the Consumer Disputes Redressal Forum under the Consumer Protection Act, 2019</li>
        <li>Seek legal remedies in the appropriate court of law</li>
      </UL>

      <P className="mt-6 text-sm">
        We are committed to maintaining the highest standards of service and fairness. Your feedback helps
        us improve.
      </P>
    </LegalPageLayout>
  );
}
